import {
  BreakPointMobile,
  BreakPointDesktop,
  BreakPointTablet,
} from "../../../constants/dimension";
import { ITheme } from "../../../constants/theme";
import { createUseStyles } from "react-jss";

// To check support for older iOS version
const hasHTMLDialog = typeof HTMLDialogElement === "function";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    insetInlineStart: 0,
    insetInlineEnd: 0,
    height: "fit-content",
    margin: "auto",
    overflow: "visible",
    outline: "none",
    background: theme.colors.Background2,
    borderRadius: theme.radius.medium,
    display: "none",
    flexDirection: "column",
    border: "none",
    width: `calc(100% - ${theme.spacing.space16}px)`,
    padding: `${theme.spacing.space24}px ${theme.spacing.space16}px`,
    gap: theme.spacing.space24,
    maxWidth: 480,
    boxSizing: "border-box",
    "&::backdrop": {
      backgroundColor: `rgba(0,0,0, 0.7)`,
    },
    ...(hasHTMLDialog
      ? {
          "&[open]": {
            display: "flex",
          },
        }
      : {
          "&.open": {
            display: "flex",
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          },
        }),
    [BreakPointMobile]: {
      padding: `${theme.spacing.space24}px ${theme.spacing.space16}px`,
      "@media (orientation: landscape)": {
        gap: theme.spacing.space20,
        maxWidth: 320,
        padding: `${theme.spacing.space16}px ${theme.spacing.space20}px`,
      },
    },
    [BreakPointDesktop]: {
      padding: theme.spacing.space48,
      maxWidth: 602,
    },
    [BreakPointTablet]: {
      padding: theme.spacing.space48,
      maxWidth: 602,
    },
  },
  rootContent: {
    display: "flex",
    flexDirection: "column",
    overflow: "scroll",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  icon: {
    paddingBottom: theme.spacing.space32,
    margin: "auto",
    textAlign: "center",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  content: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    gap: theme.spacing.space24,
    paddingBottom: theme.spacing.space24,
    [BreakPointDesktop]: {
      paddingBottom: theme.spacing.space24,
    },
    [BreakPointMobile]: {
      paddingBottom: 0,
    },
    textAlign: "center",
  },
  actions: {
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing.space16,
    justifyContent: "center",
  },
  title: {
    [BreakPointDesktop]: {
      fontSize: "32px !important",
      fontWeight: "700 !important",
      lineHeight: "45px !important",
    },
  },
  description: {
    [BreakPointDesktop]: {
      fontSize: "18px !important",
      fontWeight: "500 !important",
      lineHeight: "25px !important",
    },
  },
  btn: {
    fontSize: 16,
    fontWeight: theme.fontWeight.semiBold,
    [BreakPointMobile]: {
      fontSize: 12,
      fontWeight: theme.fontWeight.medium,
    },
  },
  footer: {
    textAlign: "center",
  },
}));
